import cn from 'classnames';
import React from 'react';

import Info from '@sats-group/icons/18/info';
import Button from '@sats-group/ui-lib/react/button';
import LinkButton from '@sats-group/ui-lib/react/link-button';
import Modal from '@sats-group/ui-lib/react/modal';
import Tag from '@sats-group/ui-lib/react/tag/tag';
import Text from '@sats-group/ui-lib/react/text';

import RichText from '../rich-text/rich-text';

import type { MemberTypeCard as Props } from './member-type-card.props';

const MemberTypeCard: React.FunctionComponent<Props> = ({
  description,
  discount,
  highlighted,
  id,
  link,
  name,
  systemId,
  tooltip,
}) => {
  const memberTypeCard = cn('member-type-card', {
    'member-type-card--highlighted': highlighted,
  });

  return (
    <div className={memberTypeCard} data-id={id} data-system-id={systemId}>
      <div className="member-type-card__descriptions">
        <div className="member-type-card__title">
          <Text
            size={Text.sizes.headline3}
            theme={highlighted ? Text.themes.emphasis : Text.themes.normal}
          >
            {name}
          </Text>
          {tooltip ? (
            <>
              <Button
                leadingIcon={<Info />}
                popoverTarget={tooltip.modal.id}
                size={Button.sizes.small}
                variant={Button.variants.tertiary}
                {...tooltip.button}
              />
              <Modal {...tooltip.modal}>
                <div className="member-type-card__tooltip-content">
                  <Text>{tooltip.text}</Text>
                </div>
              </Modal>
            </>
          ) : null}
        </div>
        {discount ? (
          <div className="member-type-card__discount">
            <Tag
              size={Tag.sizes.s}
              variant={Tag.variants.secondary}
              {...discount}
            />
          </div>
        ) : null}
        {description ? (
          <div className="member-type-card__description">
            <RichText {...description} />
          </div>
        ) : null}
      </div>
      <div className="member-type-card__link">
        <LinkButton
          {...link}
          variant={highlighted ? 'primary' : 'secondary'}
          wide={true}
          data-test-select-membertype={id}
        />
      </div>
    </div>
  );
};

export default MemberTypeCard;
